import React from 'react';
import { marked } from 'marked';
import { renderToString } from 'react-dom/server';
import { TextLink } from '@spotify-internal/encore-web';
export const renderLink = (href, title, text) => {
    return renderToString(React.createElement(TextLink, { target: "_blank", href: href },
        React.createElement("span", { dangerouslySetInnerHTML: { __html: text || title } })));
};
export class DefaultRenderer extends marked.Renderer {
    link(...args) {
        return renderLink.apply(this, args);
    }
}
